import { DownOutlined } from "@ant-design/icons";
import { Drawer } from "antd";
import "antd/lib/drawer/style/index.css";
import { useState } from "preact/hooks";

export default function SelectDropdown({placeholder, selected, elements, onSelect, callback, className, isMobileVersion, dropdownFooter='', loading = false, disabled=false}: any) {
  const [drawer, setDrawer] = useState(false);

  return (isMobileVersion ? <>
    <div className={`dropdown select-dropdown ${className}`} style="position: relative;">
      <div className={`dropdown-toggle ${loading ? 'loading': ''} ${disabled ? 'disabled' : ''}`} onClick={() => setDrawer(true)}>
        <DownOutlined/>
        {loading && 'Loading...'}
        {!loading && (selected.title || placeholder)}
      </div>
    </div>
    <Drawer
      title={placeholder}
      className="print-select-drawer"
      open={drawer} 
      onClose={() => setDrawer(false)} 
      closeIcon={<DownOutlined/>} 
      placement="bottom" 
      zIndex={120} 
      height={'60vh'}
    >
      {elements.map((element: any) => (
        <div className={`option ${selected.value === element.value || selected.value === element.title ? 'selected' : ''} ${placeholder === 'Quantity' ? 'quant-option' : ''}`} onClick={() => {
          onSelect(element.value); 
          if (callback) callback(element.value);
          setDrawer(false); 
        }}>
          <div className="option-title">{element.title}</div>
          <div className="option-description">{element.description}</div>
        </div>
      ))}
      {dropdownFooter}
    </Drawer>
    </>
    :
    <div className={`dropdown select-dropdown ${className}`} style="position: relative;">
      <div className={`dropdown-toggle ${loading ? 'loading': ''} ${disabled ? 'disabled' : ''}`}>
        <DownOutlined/>
        {loading && 'Loading...'}
        {!loading && (selected.title || placeholder)}
      </div>
      {!loading && 
        <div className="dropdown-menu dropdown-sticky">
          {elements.map((element: any) => (
            <div className="option" onClick={() => { 
              onSelect(element.value); 
              if (callback) callback(element.value);
            }}>
              <span className="option-title">{element.title}</span>
              <span className="option-description">{element.description}</span>
            </div>
          ))}
          {dropdownFooter}
        </div>
      }
    </div>
  )
}